export default __webpack_public_path__ + "static/strahovanieZhizni-5bbd116634ba7a6712dfbf8f3ed731d6.png";